import React from 'react';
import { Box } from '@mui/material';
import Header from './Header';
import Footer from './Footer';

export interface PublicLayoutProps {
  children: React.ReactNode;
}

/**
 * PublicLayout — reusable wrapper for public/marketing pages.
 * Uses the shared Header (with login/register buttons) and Footer,
 * but renders no sidebar so the full viewport width is available for content.
 */
const PublicLayout: React.FC<PublicLayoutProps> = ({ children }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh',
      }}
    >
      <Header showMenuButton={false} />

      <Box component="main" sx={{ flex: 1, paddingTop: 'var(--header-height)' }}>
        {children}
      </Box>

      <Footer />
    </Box>
  );
};

export default PublicLayout;
